import { Grid, makeStyles, Avatar } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  getProfessionalById,
  getProfessionalNotification,
  getResourceFromServer,
  updateProfessionaNotifications,
} from "../../../models/actions/Professionals";
import SpText from "../../../components/atoms/SpText";
import SpIconAndTextButton from "../../../components/atoms/SpIconAndTextButton";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { styled } from "../../../components/styled";
import { labels, psTranslate } from "../translations";
import LanguagesFlags from "../../../components/bundles/LanguagesFlags";
import { theme } from "../../../components/theme";
import NotificationsIcon from "@material-ui/icons/Notifications";
import PersonIcon from "@material-ui/icons/Person"; // Atleta
import GroupIcon from "@material-ui/icons/Group"; // Gruppo
import WorkIcon from "@material-ui/icons/Work";
import { Menu, MenuItem, IconButton, Badge } from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { useAuth0 } from "@auth0/auth0-react";
import { getNotificationSocketUrl } from "../../../models/actions/Common";
import useWebSocket from "react-use-websocket";

const TrialDiv = styled(Grid)({
  border: "1px yellow solid",
  borderRadius: "3px",
  paddingLeft: "5px",
  paddingRight: "5px",
});

const useStyles = makeStyles((theme) => ({
  largeAvatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}));

const Profile = () => {
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();

  const [professionalData, setProfessionalData] = useState(null);
  const [profileImage, setProfileImg] = useState();
  const [anchorEl, setAnchorEl] = useState(null);

  const [socketUrl, setSocketUrl] = useState(null);
  const { sendMessage, lastMessage, readyState } = useWebSocket(
    encodeURI(socketUrl),
    {
      shouldReconnect: () => true,
    },
    !!socketUrl // solo se è definito
  );
  const [notifications, setNotifications] = useState([]);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(true);

  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    if (lastMessage && lastMessage.data) {
      const parsedMessage = JSON.parse(lastMessage.data);
      setNotifications((prevNotifications) => [
        ...parsedMessage.map((item) => ({
          ...JSON.parse(item.data),
          shown: item.shown,
        })),
      ]);
      setHasUnreadNotifications(true); // Attiva il badge
    }
  }, [lastMessage]);

  const getLinkFromSection = ({
    id_patient,
    section,
    selectedEvent,
    date,
    id_presentation,
    id_group,
    subsection,
  }) => {
    let link = "";
    switch (section) {
      case "bodymap":
        link = "/patients/edit/" + id_patient;
        break;
      case "test":
        link = "/patients/edit/" + id_patient + "/monitoring/test";
        break;
      case "proms":
        link = "/patients/edit/" + id_patient + "/monitoring/proms";
        break;
      case "history":
        link = "/patients/edit/" + id_patient + "/medical_history";
        break;
      case "ioc_consensus":
        link = "/patients/edit/" + id_patient + "/phe_consensus";
        break;
      case "injury":
        link =
          "/patients/edit/" + id_patient + "/presentation/" + id_presentation;
        break;
      case "create_illness":
        link = "/patients/edit/" + id_patient + "/monitoring/illness";
        break;
      case "update_illness":
        link = "/patients/edit/" + id_patient + "/monitoring/illness";
        break;
      case "calendar":
        link = `/patients/edit/${id_patient}/plan/${parseInt(
          selectedEvent
        )}/${date}`;
        break;
      case "group_calendar":
        link = `/groups/activity/${id_group}/${parseInt(
          selectedEvent
        )}/${date}`;
        break;
      case "state":
        link = `/patients/edit/${id_patient}/${subsection}`;
        break;
      default:
        link = "";
        break;
    }
    return link;
  };

  const getIconByType = ({ url, type }) => {
    if (url)
      return (
        <Avatar
          imgProps={{
            style: {
              width: "100%",
              mHeight: "100%",
              maxWidth: "100%",
            },
          }}
          className={classes.largeAvatar}
          src={url ? url : ""}
        />
      );
    switch (type) {
      case "atleta":
        return (
          <PersonIcon
            fontSize="small"
            style={{ marginRight: 8, color: theme.colors.dark.lightBlue }}
          />
        );
      case "gruppo":
        return (
          <GroupIcon
            fontSize="small"
            style={{ marginRight: 8, color: theme.colors.dark.lightBlue }}
          />
        );
      case "pro":
        return (
          <WorkIcon
            fontSize="small"
            style={{ marginRight: 8, color: theme.colors.dark.lightBlue }}
          />
        );
      default:
        return null;
    }
  };

  const handleOpenNotifications = async (event) => {
    setAnchorEl(event.currentTarget);
    setHasUnreadNotifications(false); // Disattiva il badge
    await updateProfessionaNotifications({
      id_notifications: notifications.map((item) => item.id),
    });
  };

  const handleCloseNotifications = () => {
    setAnchorEl(null);
  };

  const fetchData = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      const idToken = await getIdTokenClaims();
      const socketUrl = await getNotificationSocketUrl();
      setSocketUrl(
        `${socketUrl}?accessToken=${accessToken}&idToken=${idToken?.__raw}`
      );
      const notifications = await getProfessionalNotification({});
      setNotifications((prevNotifications) => [
        ...notifications.map((item) => ({
          ...JSON.parse(item.data),
          shown: item.shown,
          id: item.id,
        })),
      ]);

      // setHasUnreadNotifications(true); // Attiva il badge
      setHasUnreadNotifications(
        notifications.filter((item) => item.shown == 0).length > 0
      );

      const response = await getProfessionalById();
      if (response.id_file) {
        const profileBase64 = await getResourceFromServer({
          id_file: response.id_file,
        });
        if (profileBase64) {
          setProfileImg(profileBase64);
        }
      }
      setProfessionalData(response);
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Grid
      container
      style={{ alignItems: "center", justifyContent: "flex-end" }}
    >
      {professionalData?.email && (
        <Grid
          id={"profileContainer"}
          container
          item
          xs={professionalData?.name && professionalData?.surname ? 12 : 1}
          direction="row"
          style={{ alignItems: "center" }}
        >
          {professionalData?.trial && (
            <TrialDiv>
              <SpText id={"trialText"} variant={"trialText"}>
                {labels.general.trialText}
              </SpText>
            </TrialDiv>
          )}
          <SpIconAndTextButton
            id={"profileIconButton"}
            isIconRight={true}
            text={
              professionalData?.name
                ? `${professionalData?.name} ${professionalData?.surname}`
                : ""
            }
            textVariant={"nameSurnameHeader"}
            onClick={() => history.push(`/account`)}
          >
            <Grid item style={{ padding: "3px" }}>
              <Avatar
                imgProps={{
                  style: {
                    width: "100%",
                    mHeight: "100%",
                    maxWidth: "100%",
                  },
                }}
                className={classes.largeAvatar}
                src={profileImage ? profileImage : ""}
              />
            </Grid>
          </SpIconAndTextButton>
          <IconButton
            color="inherit"
            onClick={handleOpenNotifications}
            style={{ marginLeft: 0 }}
          >
            <Badge
              badgeContent={
                hasUnreadNotifications
                  ? notifications.filter(({ shown }) => shown == 0)?.length
                  : 0
              }
              color="secondary"
            >
              <NotificationsIcon
                style={{
                  color: theme.colors.greyScale.grey2,
                }}
              />
            </Badge>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleCloseNotifications}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <div style={{ maxHeight: 200, overflowY: "auto" }}>
              {notifications.map((note, index) => (
                <MenuItem key={index} onClick={handleCloseNotifications}>
                  <Grid container alignItems="center" wrap="nowrap">
                    {getIconByType({
                      url: note?.profileImage,
                      type: note?.type,
                    })}
                    <span style={{ paddingLeft: "5px" }}>
                      {`${labels.notification[note?.title]} ${psTranslate(
                        note?.name
                      )} `}
                      <strong>{`${note?.target}`}</strong>
                    </span>

                    {note.section && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          history.push(
                            getLinkFromSection({
                              id: note?.id,
                              section: note?.section,
                              selectedEvent: note?.selectedEvent,
                              date: note?.date,
                              id_presentation: note?.id_presentation,
                              subsection: note?.subsection,
                              id_patient: note?.id_patient,
                              id_group: note?.id_group,
                            })
                          );
                          handleCloseNotifications();
                        }}
                      >
                        <ArrowForwardIcon fontSize="small" />
                      </IconButton>
                    )}
                  </Grid>
                </MenuItem>
              ))}
            </div>
          </Menu>
          <LanguagesFlags />
        </Grid>
      )}
    </Grid>
  );
};

export default Profile;
